import React from 'react';

const Card = ({ children }) => {
  return (
    <div className="card shadow">
      <div className="card-body">
        {children}
      </div>
    </div>
  );
};

export default Card;
